import { Spinner } from '@Common/Spinner';
import { useGetSubscription } from 'store/subscription/actions';

import { SubscriptionCard } from '../UI';
import { BillingInfoTab } from './BillingInfoTab';
import { InvoicesTab } from './InvoicesTab';
import { PaymentMethodsTab } from './PaymentMethodsTab';

export const ActiveSubscriptionPage = () => {
  const { data: subscription, isPending: isSubscriptionPending } = useGetSubscription();

  return (
    <>
      <div className="flex flex-col space-y-6">
        {isSubscriptionPending ? (
          <Spinner color="bg-primary" />
        ) : (
          <div className="w-full flex items-center flex-wrap gap-5">
            {subscription?.subscriptions.map((subscription) => (
              <SubscriptionCard
                key={'subscription-system-' + subscription.id}
                subscription={subscription}
              />
            ))}
          </div>
        )}
        <BillingInfoTab />
        <PaymentMethodsTab />
        <InvoicesTab />
      </div>
    </>
  );
};
